//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmailPreviewModalLoader from "../email-preview-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PreviewEmailStep",
  components: {
    EmailPreviewModalLoader
  },
  props: {
    previewEmail: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$emit("load-email-preview");
  }
});